import actionTypes from './GTMWTWTR01ActionType';

/**
 * 作業時間登録
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 作業時間登録を登録するReducer
 * @param {*} state
 * @param {*} action
 */
export const saveWorkingtime = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_WORKINGTIME_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.SAVE_WORKINGTIME_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.SAVE_WORKINGTIME_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.SAVE_WORKINGTIME_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
